// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyATyqpTLVYDE02WHwI57_Ah2FoIYwdQVic",
  authDomain: "dothink-new.firebaseapp.com",
  projectId: "dothink-new",
  storageBucket: "dothink-new.firebasestorage.app",
  messagingSenderId: "381712464387",
  appId: "1:381712464387:web:5f9b6663904415dce0ac36",
  measurementId: "G-B580H7S6LD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

